import React, {Fragment} from "react";
import toast from "react-hot-toast";
import {ReactComponent as CloseIcon} from "./close.svg";
import "./ReDeploy.css";
import config, { getApiUrl } from "./config";
import authService from "./AuthService";
import DeployTimer from "./DeployTimer";

type ReDeployProps = {
    endpointId: string;
    endpointState: string;
    endpointPlatform: string;
    closeCallback: () => void;
}

type ReDeployState = {
    platform: string;
    platforms: PlatformListEntry[];
    deploymentToken: string;
}

type PlatformListEntry = {
    name: string;
    friendlyName: string;
    manufacturer: string;
    model: string;
}

class ReDeploy extends React.Component<ReDeployProps, ReDeployState> {
    constructor(props: ReDeployProps) {
        super(props);
        this.state = {
            platform: props.endpointPlatform,
            platforms: [],
            deploymentToken: ""
        }
    }

    componentDidMount() {
        if (this.state.platform === "") {
            this.getPlatforms();
        } else {
            this.getDeploymentToken();
        }
    }

    private getPlatforms() {
        fetch(getApiUrl() + "/v1/component/platform/", {
            method: "GET",
            headers: [
                ["Accept", "application/json"],
                ["Authorization", authService.authHeader()]
            ]
        })
            .then(response => response.json() as Promise<Array<PlatformListEntry>>)
            .then((response) => {
                console.log(response)
                this.setState({
                    platforms: response
                })
            })
            .catch((error) => {
                toast.error("Failed to get deployment platforms: " + error);
            });
    }

    private getDeploymentToken() {
        fetch(getApiUrl() + "/v1/endpoint/" + this.props.endpointId + "/deploy-token", {
            method: "GET",
            headers: [
                ["Accept", "application/jwt"],
                ["Authorization", authService.authHeader()]
            ]
        })
            .then(response => response.text() as Promise<string>)
            .then((response) => {
                this.setState({
                    deploymentToken: response
                })
            })
            .catch((error) => {
                toast.error("Failed to get deployment token: " + error);
            });
    }

    private copyDeployScriptToClipboard = (event: React.MouseEvent<HTMLPreElement, MouseEvent>) => {
        navigator.clipboard.writeText(this.getScript()).then(r => () => {
            toast.success("Copied deploy script to clipboard");
        });
    }

    private copyCleanStepToClipboard() {
        navigator.clipboard.writeText("docker ps -aq | xargs docker rm --force && docker images -q | xargs docker rmi").then(r => () => {
            toast.success("Copied clean script to clipboard");
        });
    }

    public getScript() {
        return "HISTFILE=/dev/null bash -c \"$(curl " + config.ApiUrl + "/v1/endpoint/" + this.props.endpointId + "/deploy.sh?platform=" + this.state.platform + " -H 'Authorization: Bearer "+this.state.deploymentToken+"')\"";
    }

    public renderDeploymentScript() {
        if (this.state.deploymentToken) {
            return <Fragment>
            <pre className="ReDeploy-script"
                        onClick={this.copyDeployScriptToClipboard}>{this.getScript()}</pre>
            <br/>
            <small className="ReDeploy-script-annotation">Click script to copy the command to the clipboard</small>
            </Fragment>;
        } else {
            return <Fragment>
            <pre className="ReDeploy-script loading">Loading deployment token...</pre>
                <br/>
                <small className="ReDeploy-script-annotation">Click script to copy the command to the clipboard</small>
                </Fragment>
        }
    }

    public renderDeployInstructions() {
        return <div>
            <h3>Deploy the software</h3>
            <DeployTimer expiration={new Date(new Date().getTime() + 30 * 60 * 1000)}/>
            <p>To deploy the software, open a SSH connection to the CC100 and run the following command:</p>
            {this.renderDeploymentScript()}

        </div>
    }

    public renderRedeployInstructions() {
        return <div>
            <h3>Remove all containers and images</h3>
            <pre className="ReDeploy-script" onClick={this.copyCleanStepToClipboard}>docker ps -aq | xargs docker rm --force && docker images -q | xargs docker rmi</pre>
            <br/>
            <small className="ReDeploy-script-annotation">Click script to copy the command to the clipboard</small>
            <h3>Deploy the software</h3>
            <p>Now you can redeploy the software by using the following command:</p>
            {this.renderDeploymentScript()}
        </div>
    }

    private renderPlatformSelector() {
        if (this.state.platforms.length === 0) {
            return <div className="loading">Loading platforms...</div>;
        } else {
            return <Fragment>
                <h3>Select platform</h3>
                <div className="ReDeploy-platforms">
                    {this.state.platforms.map((platform) => {
                        return <button key={platform.name} onClick={() => {
                            this.setState({
                                platform: platform.name
                            });
                            this.getDeploymentToken();
                        }}>{platform.manufacturer} {platform.friendlyName} ({platform.model})</button>
                    })}
                </div>
            </Fragment>
        }
    }

    public render() {
        return <div className="ReDeploy">
            <div className="ReDeploy-content">
                <div className="ReDeploy-controls">
                    <div className="ReDeploy-title">{this.props.endpointState === "NEW" ? "Deploy" : "Redeploy"}</div>
                    <span className="ReDeploy-spacer"/>
                    <button className="ReDeploy-close" onClick={this.props.closeCallback}><CloseIcon/></button>
                </div>
                <div className="ReDeploy-scrollarea">
                    {this.state.platform === "" ? this.renderPlatformSelector() : this.props.endpointState == "NEW" ? this.renderDeployInstructions() : this.renderRedeployInstructions()}
                </div>
            </div>
        </div>
    }
}

export default ReDeploy;